<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="text-center">Subathon Timer Settings</h1>
      </v-col>
    </v-row>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="commands"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-dialog persistent v-model="dialog" max-width="80vw">
          <v-card>
            <v-form ref="form" v-model="formValid">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field v-model="editedItem.event" label="Event" disabled></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.anz_sec"
                        label="Sekunden pro Event"
                        type="Number"
                        :rules="rulesWith0"
                        min="0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save" :loading="saving">Save</v-btn>
              </v-card-actions>
            </v-form>
            <v-snackbar v-model="ErrorFlag" timeout="3000" color="red">
              Überprüfe die roten Felder!
              <template v-slot:actions>
                <v-btn color="pink" variant="text" @click="ErrorFlag = false">Close</v-btn>
              </template>
            </v-snackbar>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
              :disabled="$store.state.user_perm < 6"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editieren!</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dialog">Reset</v-btn>
      </template>
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card v-for="item in mobileItems" :key="item.id" class="mb-3" outlined>
        <v-card-title class="py-2">{{ item.event }}</v-card-title>
        <v-card-text class="pt-0">
          <v-chip small color="info">{{ item.anz_sec }}s pro Event</v-chip>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="editItem(item)" :disabled="$store.state.user_perm < 6">
            <v-icon color="success">mdi-pencil</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-alert v-if="mobileItems.length === 0" type="info" class="mt-2">
        Keine Einträge gefunden.
      </v-alert>

      <!-- Mobile Edit Dialog (fullscreen) -->
      <v-dialog v-model="dialog" fullscreen>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Event bearbeiten</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text @click="save" :loading="saving">Speichern</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="form" v-model="formValid">
            <v-container class="pa-4">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="editedItem.event" label="Event" disabled outlined></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.anz_sec"
                    label="Sekunden pro Event"
                    type="Number"
                    :rules="rulesWith0"
                    min="0"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-snackbar v-model="ErrorFlag" timeout="3000" color="red">
              Überprüfe die roten Felder!
              <template v-slot:actions>
                <v-btn color="pink" variant="text" @click="ErrorFlag = false">Close</v-btn>
              </template>
            </v-snackbar>
          </v-form>
        </v-card>
      </v-dialog>
    </template>

    <div class="custom-container3">
      <v-row>
        <v-col cols="12">
          <p class="text-center">
            <span style="color: #00ffcd;">Subathon Timer Link:</span>
            {{ baseUrl }}/{{ obstoken }}
          </p>
        </v-col>
        <v-col cols="12">
          <h3 class="text-center">Subathon Timer Commands zusammengefasst:</h3>
        </v-col>
        <v-col cols="12">
          <p class="text-center">
            <span style="color: #00ffcd;">Timer einstellen:</span>
            !timer init 1:00:00
          </p>
        </v-col>
        <v-col cols="12">
          <p class="text-center">
            <span style="color: #00ffcd;">Timerzeit hinzufügen / abziehen in Sekunden:</span>
            !timer add 300 / !timer add -500
          </p>
        </v-col>
        <v-col cols="12">
          <p class="text-center">
            <span style="color: #00ffcd;">Timer starten / stoppen:</span>
            !timer start / !timer stop
          </p>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  name: 'SubathonTimer',
  data: () => ({
    search: '',
    dialog: false,
    obstoken: '',
    baseUrl: '',
    commands: [],
    saving: false,
    headers: [
      { text: 'Event', value: 'event', align: 'center' },
      { text: 'Sekunden pro Event', value: 'anz_sec', align: 'center' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    formValid: false,
    rulesPositiveNumber: [
      (v) => !!v || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) > 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    rulesWith0: [
      (v) => (v !== null && v !== undefined) || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) >= 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    ErrorFlag: false,
  }),
  mounted() {
    this.baseUrl = window.location.origin;
    const subdomain = 'subathon';
    this.baseUrl = this.baseUrl.replace(/:\/\/(.*?)(\/|$)/, `://${subdomain}.$1$2`);
    BackendService.loadSubathonTimerSettings().then((data) => {
      this.commands = data.data;
    });
    BackendService.loadObsToken({
      broadcasterid: this.$store.state.hostId,
    }).then((data) => {
      this.obstoken = data.data.obs_token;
    });
  },
  computed: {
    mobileItems() {
      if (!this.search) return this.commands;
      const s = this.search.toLowerCase();
      return this.commands.filter((c) => c.event && c.event.toLowerCase().includes(s));
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.commands.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        BackendService.saveSubathonTimerSettings({
          id: this.editedItem.id,
          event: this.editedItem.event,
          anz_sec: this.editedItem.anz_sec,
        }).then((data) => {
          this.commands = data.data;
          this.saving = false;
          this.close();
        });
      } else this.ErrorFlag = true;
    },
  },
};
</script>

<style>
.chipGroup label {
  font-size: 12px;
}
</style>
